const en = {
  header: {
    wash: 'Wash',
    insurance: 'Insurance',
    shop: 'Shop',
    premium: 'Premium',
    aboutUs: 'About Us',
    help: 'Help',
    sendToPhone: 'Send to my phone'
  },
  common: {
    title: 'Neatcar LiveMap',
    buyAWash: 'Buy a wash',
    moreDetails: 'More detail',
    Activities: 'Activities',
    Washes: 'Washes',
    // eslint-disable-next-line no-template-curly-in-string
    price: '${{price}}',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD',
    inAppPrices: 'In-app prices',
    reportedBy: 'Reported by',
    buyFromPhone: 'Buy your car washes from your phone',
    sendToPhone: 'Send to my phone',
    sendToPhoneDesc: 'Send the download link to your phone',
    downloadApp: 'Download the Neatcar app',
    appStoreLink: 'https://apps.apple.com/ca/app/neatcar/id1499030487',
    playStoreLink: 'https://play.google.com/store/apps/details?id=com.mecommerce.carwashremote&hl=en_CA',
    scanTheCode: 'Scan the code with your phone',
    scanTheCodeDesc: 'Use your phone\'s camera to scan and download the Neatcar app.',
    download: 'Download',
    downloadDesc: 'Download the Neatcar app on your phone from',
    choose: 'Choose your car wash',
    chooseDesc: 'Choose your car wash among our partners and select the wash type you like',
    pay: 'Buy',
    payDesc: 'Once your wash type chosen, buy it and use the code from your phone directly at the station',
    
    // Store detail specific
    carWash: 'Car Wash',
    carWashStation: 'Car wash station',
    realTimeAvailability: 'Real-time availability on Neatcar Live Map.',
    contactCarWash: 'Contact Car Wash',
    touchlessCarWash: 'Touchless Car Wash',
    closePanel: 'Close panel',
    discount: 'Discount',
    locatedAt: 'located at',
    promoCode: 'Promo Code',
    freeTrialOffer: '3 months Premium FREE'
  },
  seo: {
    // Main page SEO
    mainTitle: 'Neatcar Live Map - Find Car Wash Stations Near You',
    mainDescription: 'Discover car wash stations near you with Neatcar\'s interactive live map. Real-time availability, pricing, and locations across Canada.',
    mainKeywords: 'car wash, neatcar, live map, car wash near me, my car wash, car wash station, touchless car wash, canada, real time availability, car wash map',
    
    // Dynamic SEO content
    stationsText: 'Car Wash Stations',
    findText: 'Find',
    mapText: 'Interactive map with real-time availability and navigation.',
    pricesFromText: 'Prices from',
    toText: 'to',
    checkPricingText: 'Check real-time pricing.',
    acrossText: 'across',
    canadaText: 'Canada',
    inText: 'in',
    fromText: 'from',
    
    // Store detail SEO
    storeTitle: '{{brandName}} Car Wash – {{streetName}}, {{city}} | Neatcar Live Map',
    storeDescription: '{{brandName}} car wash on {{streetName}} in {{city}}. View prices and live availability.',
    storeKeywords: '{{brandName}}, car wash, {{address}}, {{city}}, {{province}}, neatcar, touchless, gas station',
    
    // Keywords for different contexts
    keywords: {
      base: ['car wash', 'neatcar', 'live map', 'car wash near me', 'touchless car wash', 'canada', 'real time availability', 'my car wash', 'car wash station', 'car wash map'],
      location: ['car wash {{province}}', '{{province}} car wash stations', 'car wash map {{province}}', '{{province}} car wash locations'],
      brand: ['{{brand}} car wash', '{{brand}} station', '{{brand}} car wash map']
    }
  }
};

export default en;
